<button
  mat-icon-button
  class="position-absolute d-block d-lg-none menu-button"
  aria-label="Example icon-button with menu icon"
  (click)="handleClick()"
>
  <mat-icon>menu</mat-icon>
</button>